import React from 'react';

import {cx} from 'emotion';
import PropTypes from 'prop-types';

import {ReactComponent as FullLogo} from 'static/images/icons/logos/Newsela_fulllogo_reducedsize_RGB.svg';
import {ReactComponent as LogoMark} from 'static/images/icons/logos/Newsela_mark_reducedsize_RGB.svg';

import {
  logoMarkStyle
} from './style';

const propTypes = {
  additionalClassName: PropTypes.string,
  fullSizeMediaQuery: PropTypes.string,
  showFullSize: PropTypes.bool,
};

export const Logo = React.forwardRef((props, ref) => {
  const svgProps = {
    'data-qa-selector': 'header_logo'
  };
  const className = cx([
    logoMarkStyle(props.showFullSize, props.fullSizeMediaQuery),
    props.additionalClassName
  ]);


  return (
    <div
      ref={ref}
      className={className}
    >
      <FullLogo
        {...svgProps}
      />
      <LogoMark
        {...svgProps}
      />
    </div>
  );
});

Logo.propTypes = propTypes;
export default Logo;
